import { IconComponent } from './types';

const CropVarietyIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={10}
    viewBox="0 0 7 10"
    fill="none"
    {...props}
  >
    <path fill="#909090" d="M3.294.026h.412v9.476h-.412V.026Z" />
    <path
      fill="#909090"
      d="M.823 0h5.353v.38H.823zM.823 4.941h5.353v.38H.823zM.823 9.502h5.353v.38H.823z"
    />
    <ellipse cx={3.5} cy={5.131} fill="#F9F9F9" rx={3.5} ry={3.231} />
    <path
      stroke="#212121"
      strokeOpacity={0.5}
      strokeWidth={0.5}
      d="M6.75 5.131c0 1.628-1.436 2.98-3.25 2.98S.25 6.76.25 5.132s1.436-2.98 3.25-2.98 3.25 1.352 3.25 2.98Z"
    />
    <path
      fill="#909090"
      d="M.342 4.94H6.66v.381H.342v-.38ZM.412 6.46h6.176l-.411.381H.824l-.412-.38ZM.823 3.42h5.48l.285.381H.674l.15-.38Z"
    />
  </svg>
);
export default CropVarietyIcon;
